import { DialogId } from 'account/recurring-payment/lib';
import { useUpdateTranslations } from 'account/recurring-payment/lib/translations';
import { BasicLoader } from 'components/loaders/basic-loader';
import { StandardDialogWrapper } from './common';
import './updating.dialog.scss';

const UpdatingDialog = () => {
  const { processingUpdate } = useUpdateTranslations();

  return <StandardDialogWrapper id={DialogId.updating}>
    <>
      <BasicLoader isLoading={true} />

      <p>
        {processingUpdate}
      </p>
    </>
  </StandardDialogWrapper>
}

export default UpdatingDialog;